export default __webpack_public_path__ + "static/SpaceGrotesk-SemiBold-0c90cf115980aae34f07bff8c24fb6bc.ttf";